const AmountRegex = /^[0-9]*$/g;
export const StringRegex = /^[a-zA-Z]*$/;

export const validateAmountInput = (oldValue, newValue) => {
  if (
    newValue.split("").filter((i) => i !== "." && isNaN(parseInt(i))).length > 0
  ) {
    return oldValue;
  }
  let decimalSections = newValue.split(".");
  if (decimalSections.length > 2) {
    return oldValue;
  }
  if (decimalSections.length === 2 && decimalSections[1].length > 2) {
    //only allow two decimal places
    return false;
  }
  return newValue;
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email); // Returns true if valid, false if not
};

export const validateNumber = (oldValue, newValue) => {
  if (newValue.split("").filter((i) => i && isNaN(parseInt(i))).length > 0) {
    return oldValue;
  }
  return newValue;
};

export const validateCardOrAccountNumber = (oldValue, newValue) => {
  if (newValue.split("").filter((i) => isNaN(parseInt(i))).length > 0) {
    return oldValue;
  }
  return newValue;
};

export const validateUserPassword = (password) => {
  let res = {
    status: false,
    hasCharCount: password.length >= 8,
    hasLower: password.toUpperCase() != password,
    hasUpper: password.toLowerCase() != password,
    hasNumbers: /\d/.test(password),
  };
  console.log("validateUserPassword:", res);
  res.status =
    res.hasLower && res.hasUpper && res.hasNumbers && res.hasCharCount;
  return res;
};
